import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike'
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun'
import PoolIcon from '@mui/icons-material/Pool'

import FormCheckboxGroup, {
  Option,
} from 'components/forms/elements/FormCheckboxGroup'
import FormSelectInput from 'components/forms/elements/FormSelectInput'
import FormTextInput from 'components/forms/elements/FormTextInput'
import {
  ALL_TSHIRT_SIZES,
  EVENT_SHIRT_OPTIONS,
  TEAM_TYPES,
  TSHIRT_SIZES,
} from 'constants/models'
import { Priority } from 'models/API'
// import { isCategoryMultisports, isCategoryRelay } from 'utils/ApiHelpers'
import { isCategoryRelay } from 'utils/ApiHelpers'

interface CategoryProps {
  id: string
  name: string
  priority: number
  disabled?: boolean
}

const shirtFieldInputs = ({ key, fullShirtDetails, formDisabled }) => [
  {
    ...((key === 1 || (key === 2 && fullShirtDetails.hasShirt2)) &&
      `SHIRT${key}` in fullShirtDetails.shirtDetails &&
      'TYPE_OPTIONS' in fullShirtDetails.shirtDetails[`SHIRT${key}`] && {
        id: `${key > 1 ? `shirtType${key}` : 'shirtType'}`,
        size: { sm: 12, md: 6 },
        field: (
          <FormSelectInput
            name={`${key > 1 ? `shirtType${key}` : 'shirtType'}`}
            label={`${
              fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
            }`}
            autoComplete={`${
              key > 1 ? `new-shirtType${key}` : 'new-shirtType'
            }`}
            placeholder={`Select ${
              fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
            }`}
            disabled={formDisabled}
            options={(
              fullShirtDetails.shirtDetails[`SHIRT${key}`].TYPE_OPTIONS ||
              EVENT_SHIRT_OPTIONS
            ).map((key) => ({
              value: key,
              text: key,
            }))}
            required
          />
        ),
      }),
  },
  {
    ...((key === 1 || (key === 2 && fullShirtDetails.hasShirt2)) && {
      id: `${key > 1 ? `shirtSize${key}` : 'shirtSize'}`,
      size: { sm: 12, md: 6 },
      field: (
        <FormSelectInput
          name={`${key > 1 ? `shirtSize${key}` : 'shirtSize'}`}
          label={`${
            fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
          } size`}
          autoComplete={`${key > 1 ? `new-shirtSize${key}` : 'new-shirtSize'}`}
          placeholder={`Select ${
            fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
          } Size`}
          disabled={formDisabled}
          options={
            `SHIRT${key}` in fullShirtDetails.shirtDetails &&
            'SIZE_OPTIONS' in fullShirtDetails.shirtDetails[`SHIRT${key}`]
              ? fullShirtDetails.shirtDetails[`SHIRT${key}`].SIZE_OPTIONS.map(
                  (value: string) => ({
                    value,
                    text: ALL_TSHIRT_SIZES[value],
                  }),
                )
              : Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
                  value: key,
                  text: value,
                }))
          }
          required
        />
      ),
    }),
  },
]

const category = ({
  values,
  categories,
  onCategoryChange,

  currentRelayEvent,
  selectedRelayEvent,
  onRelayEventChange,

  fullShirtDetails,
  hasJersey,

  hasBibName,

  subCategories,

  formDisabled,
}) => [
  {
    id: 'categoryId',
    size: { sm: 12, md: 6 },
    field: (
      <FormSelectInput
        name="categoryId"
        label="Category"
        autoComplete="new-categoryId"
        disabled={formDisabled}
        placeholder="Select Category"
        options={categories
          .sort((a: CategoryProps, b: CategoryProps) => {
            if (!!a.priority && !b.priority) return -1
            if (!!b.priority && !a.priority) return 1
            return a.priority - b.priority
          })
          .map((category: CategoryProps) => ({
            value: category.id,
            text: category.name,
            disabled: category.disabled,
          }))}
        onModified={onCategoryChange}
        required
      />
    ),
  },
  {
    ...(isCategoryRelay(values) && {
      id: 'relayEvent',
      size: { sm: 12, md: 6 },
      field: (
        <FormCheckboxGroup
          name="relayEvent"
          label="Relay Event"
          required
          options={
            [
              ...(values.teamType === TEAM_TYPES.DUATHLON
                ? [
                    {
                      text: 'RUN 1',
                      value: 'RUN1',
                      image: <DirectionsRunIcon />,
                      disabled:
                        !currentRelayEvent.includes('RUN1') &&
                        selectedRelayEvent.includes('RUN1'),
                    },
                  ]
                : [
                    {
                      text: 'SWIM',
                      value: 'SWIM',
                      image: <PoolIcon />,
                      disabled:
                        !currentRelayEvent.includes('SWIM') &&
                        selectedRelayEvent.includes('SWIM'),
                    },
                  ]),
              {
                text: 'BIKE',
                value: 'BIKE',
                image: <DirectionsBikeIcon />,
                disabled:
                  !currentRelayEvent.includes('BIKE') &&
                  selectedRelayEvent.includes('BIKE'),
              },
              {
                text: 'RUN 2',
                value: `RUN${
                  values.teamType === TEAM_TYPES.DUATHLON ? '2' : ''
                }`,
                image: <DirectionsRunIcon />,
                disabled:
                  !currentRelayEvent.includes(
                    `RUN${values.teamType === TEAM_TYPES.DUATHLON ? '2' : ''}`,
                  ) &&
                  selectedRelayEvent.includes(
                    `RUN${values.teamType === TEAM_TYPES.DUATHLON ? '2' : ''}`,
                  ),
              },
            ] as Option[]
          }
          checkedOptions={values.relayEvent}
          disabled={formDisabled}
          placeholder="Select at least 1 Relay Event"
          onModified={onRelayEventChange}
        />
      ),
    }),
  },
  ...shirtFieldInputs({ key: 1, fullShirtDetails, formDisabled }),
  ...shirtFieldInputs({ key: 2, fullShirtDetails, formDisabled }),
  {
    ...(hasJersey &&
      (values.isIndividual || values.relayEvent.includes('BIKE')) && {
        id: 'jerseySize',
        size: { sm: 12, md: 6 },
        field: (
          <FormSelectInput
            name="jerseySize"
            label={`${
              fullShirtDetails.shirtDetails?.JERSEY?.LABEL || 'Cycling jersey'
            } size`}
            autoComplete="new-jerseySize"
            placeholder={`Select ${
              fullShirtDetails.shirtDetails?.JERSEY?.LABEL || 'Cycling jersey'
            } size`}
            disabled={formDisabled}
            // options={Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
            //   value: key,
            //   text: value,
            // }))}
            options={
              `JERSEY` in fullShirtDetails.shirtDetails &&
              'SIZE_OPTIONS' in fullShirtDetails.shirtDetails.JERSEY
                ? fullShirtDetails.shirtDetails.JERSEY.SIZE_OPTIONS.map(
                    (value: string) => ({
                      value,
                      text: ALL_TSHIRT_SIZES[value],
                    }),
                  )
                : Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
                    value: key,
                    text: value,
                  }))
            }
            required
          />
        ),
      }),
  },
  {
    id: 'teamName',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="teamName"
        label="Team Name"
        autoComplete="new-teamName"
        disabled={formDisabled}
      />
    ),
  },
  {
    ...(hasBibName && {
      id: 'bibName',
      size: { sm: 12, md: 6 },
      field: (
        <FormTextInput
          name="bibName"
          label="Name in bib"
          autoComplete="new-bibName"
          disabled={formDisabled}
        />
      ),
    }),
  },

  {
    ...(subCategories &&
      Object.keys(subCategories).length > 0 && {
        id: 'subCategory',
        size: { sm: 12, md: 6 },
        field: (
          <FormSelectInput
            name="subCategory"
            label={subCategories.label}
            autoComplete="new-subCategory"
            placeholder={`Select ${subCategories.label}`}
            disabled={formDisabled}
            options={subCategories.options
              .sort((a, b: Priority) => a.priority - b.priority)
              .map((value: Priority) => ({
                value: value.name,
                text: value.name,
              }))}
            required={'required' in subCategories && subCategories.required}
          />
        ),
      }),
  },
]

export default category
